// Live Routes
export const ROUTE_LOGIN = "/login";
export const ROUTE_SIGN_UP = "/sign-up";
export const ROUTE_REGISTER = "/register";

export const ROUTE_APP = "/";
export const ROUTE_HOME = "/home";

// NOT LIVE ROUTES
export const ROUTE_START = "/start";
export const ROUTE_START_CREATE_ACCOUNT = "/start/create-account";
export const ROUTE_START_TFA_SETUP = "/start/tfa";

export const ROUTE_ONBOARDING = "/onboarding";
export const ROUTE_ONBOARDING_CONTACT_INFORMATION =
  "/onboarding/contact-information";
export const ROUTE_ONBOARDING_IDENTITY = "/onboarding/identity";
export const ROUTE_ONBOARDING_EMPLOYMENT = "/onboarding/employment";
export const ROUTE_ONBOARDING_FINANCIAL = "/onboarding/financial";
export const ROUTE_ONBOARDING_TERMS = "/onboarding/terms";

export const ROUTE_ACCOUNT = "/account";
export const ROUTE_ACCOUNT_TYPE = "/account/type";
export const ROUTE_ACCOUNT_RETIREMENT = "/account/retirement";
export const ROUTE_ACCOUNT_PLAN = "/account/plan";
export const ROUTE_ACCOUNT_SUBSCRIPTION = "/account/subscription";
export const ROUTE_ACCOUNT_CONFIRM = "/account/confirm";
export const ROUTE_ACCOUNT_SUCCESS = "/account/success";

export const ROUTE_ACCOUNT_FUND = "/account/fund";

export const ROUTE_DEPOSIT = "/deposit/:accountId";

export const ROUTE_RECURRING_DEPOSIT = "/recurring-deposit/:accountId";

export const ROUTE_SETTINGS = "/settings";

export const ROUTE_ACCOUNTS = "/accounts";
export const ROUTE_ACCOUNTS_DETAILS = "/accounts/:accountId";

export const ROUTE_TRANSACTIONS = "/transactions";

export const ROUTE_CALCULATOR = "/calculator";

